module.exports = __webpack_public_path__ + "img/17.84baf708.png";